export function* Repeat<T>(expr: T, n = 1): Iterable<T> {
  for (let i = 1; i <= n; i++) {
    yield expr
  }
}
